export default __webpack_public_path__ + "static/media/Grimherald Robe.43983481.jpg";